import React, { FC } from 'react';

import { BOLINDA_ICON_BOLINDA_ONLY } from '../common/Button/Icon';
import { NavigationLink } from '../navigation/NavigationLink';

import './MainNavigation.scss';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly isCatalogueManagementAdmin: boolean;
};

const MainNavigation: FC<Props> = ({ isCatalogueManagementAdmin }) => {
    const { t } = useTranslation();

    return (
        <ul className="main-nav">
            <li>
                <ShopLink />
            </li>
            <li>
                <YourBorrowBoxLink />
            </li>
            {isCatalogueManagementAdmin && (
                <li>
                    <NavigationLink external={true} href="/cm">
                        <span className="main-nav-icon">
                            <i className="bolinda-icons">{BOLINDA_ICON_BOLINDA_ONLY}</i>
                            {t('menu.catalogue')}
                        </span>
                    </NavigationLink>
                </li>
            )}
        </ul>
    );
};

export default MainNavigation;

const SHOP_ALTERNATIVE_ROUTES = [
    '/libxchange',
    '/unlimited',
    '/language',
    '/assistant',
    '/orderlists',
    '/cart',
    '/checkout',
    '/orders',
    '/terms-conditions'
];

const ShopLink: FC = () => {
    const { t } = useTranslation();
    return (
        <NavigationLink to="/catalogue" alternativeRoutes={SHOP_ALTERNATIVE_ROUTES}>
            {t('menu.shopMain')}
        </NavigationLink>
    );
};

const YOUR_BORROWBOX_ALTERNATIVE_ROUTES = ['/localcontent', '/marketing'];

const YourBorrowBoxLink: FC = () => {
    const { t } = useTranslation();

    return (
        <NavigationLink to="/collection" alternativeRoutes={YOUR_BORROWBOX_ALTERNATIVE_ROUTES}>
            {t('menu.yourBorrowboxMain')}
        </NavigationLink>
    );
};
